import React from "react";
import { SmlLogo } from "../components/Logo";

const VendorLinks = ({ url, label }: { url: string; label: string }) => {
  return (
    <a
      className="font-extrabold tracking-wider transition-colors text-gray-800 hover:text-blue-600"
      href={url}
      target="_blank"
    >
      {label}
    </a>
  );
};

const Resellers = () => {
  return (
    <>
      <SmlLogo />
      <div
        className="h-screen gap-3 flex flex-col items-center justify-center"
        style={{ backgroundImage: "url(nice-image)" }}
      >
        <VendorLinks
          url="https://mechboards.co.uk/products/bt60-pcb?variant=40336260268237"
          label="Mechboards"
        />
        <VendorLinks
          url="https://keygem.store/collections/pcb/products/bt60-60-bluetooth-pcb"
          label="Keygem"
        />
        <VendorLinks
          url="https://www.upgradekeyboards.com/product/bt60-60-wireless-hotswap-tray-mount-wired-or-wireless-pcb/"
          label="UpgradeKeyboards"
        />
      </div>
    </>
  );
};
export default Resellers;
